import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { APP_CONFIG, AppConfig } from './app/app-config';

if (environment.production) {
  enableProdMode();
}

fetch(environment.apiConfigFile)
  .then(response => {
    if (!response.ok) {
      throw new Error(`Failed to load config: ${environment.apiConfigFile}`);
    }
    return response.json();
  })
  .then((config: AppConfig) => {
    platformBrowserDynamic([
      { provide: APP_CONFIG, useValue: config }
    ])
      .bootstrapModule(AppModule)
      .catch(err => console.error(err));
  })
  .catch(err => console.error(err));
